import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';

import { Button as ScoutButton } from '@/components/NewUI/ComponentsLibrary';

import { classes } from './styles';

export interface IGenericDialogProps {
  url: string;
  title: string;
  description: string;
  moreContent?: string;
  buttonText: string;
  buttonCallback: (url: string, id: number) => void;
  callbackLoading: boolean;
  isDialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  // Optional secondary action rendered alongside the primary button, e.g. "Find matching
  // talent" next to "Continue editing" on the post-Job-creation dialog (UIUX-4252). Omitting
  // it leaves the dialog exactly as it was — a single primary action.
  secondaryButtonText?: string;
  secondaryButtonCallback?: () => void;
}

const GenericDialog = ({
  url,
  title,
  description,
  moreContent,
  buttonText,
  buttonCallback,
  callbackLoading,
  isDialogOpen,
  setDialogOpen,
  secondaryButtonText,
  secondaryButtonCallback
}: IGenericDialogProps) => (
  <Dialog
    open={isDialogOpen}
    sx={{ '& .MuiPaper-root': classes.dialog, zIndex: '20000' }}
    onClose={() => {
      setDialogOpen(false);
      if (title === 'Complete' && url) buttonCallback(url, 0);
    }}
  >
    <CloseIcon
      sx={classes.closeIcon}
      onClick={() => {
        setDialogOpen(false);
        url && buttonCallback(url, 0);
      }}
    />
    {title !== 'Failed' ? (
      <Box sx={classes.tickWrapper}>
        <DoneIcon sx={classes.tickGreen} />
      </Box>
    ) : (
      <Box sx={classes.crossWrapper}>
        <CloseIcon sx={classes.crossRed} />
      </Box>
    )}
    <Box sx={classes.dialogHeader}>{title}</Box>
    {description ? <Box>{description}</Box> : null}
    {moreContent ? <Box>{moreContent}</Box> : null}
    <Box sx={classes.dialogButtonContainer}>
      {secondaryButtonText ? (
        <ScoutButton
          buttonVariant="secondary"
          data-testid={`${secondaryButtonText.toLowerCase().split(' ').join('-')}-button`}
          id={`${secondaryButtonText.toLowerCase().split(' ').join('-')}-button`}
          onClick={secondaryButtonCallback}
        >
          {secondaryButtonText}
        </ScoutButton>
      ) : null}
      <Button
        disableElevation
        data-testid={`${buttonText.toLowerCase().split(' ').join('-')}-button`}
        id={`${buttonText.toLowerCase().split(' ').join('-')}-button`}
        style={{ padding: '10px 30px' }}
        sx={title !== 'Failed' ? classes.confirmationButton : classes.buttonRed}
        onClick={() => {
          buttonCallback(url, 0);
          if (title === 'Complete' && url) window.open(url);
        }}
      >
        {callbackLoading ? <CircularProgress color="inherit" size={20} /> : buttonText}
      </Button>
    </Box>
  </Dialog>
);

export default GenericDialog;
